import { render, staticRenderFns } from "./DeliveryTimesCard.vue?vue&type=template&id=556b6599&scoped=true"
import script from "./DeliveryTimesCard.vue?vue&type=script&lang=js"
export * from "./DeliveryTimesCard.vue?vue&type=script&lang=js"
import style0 from "./DeliveryTimesCard.vue?vue&type=style&index=0&id=556b6599&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "556b6599",
  null
  
)

export default component.exports